export enum TenantInvitationStatus {
  ACCEPTED = 'ACCEPTED',
  PENDING = 'PENDING',
}
